import React, { useEffect, useState } from 'react'
import { Dismiss, SecondLine, Wrapper } from './atoms'
import { getCookie, isLowerBrowserForWebP, setCookie } from '../../../../utils'

export const BrowserTip = () => {
  const [show, setShow] = useState(false)
  const [url, setUrl] = useState('')
  const [browser, setBrowser] = useState('')

  useEffect(() => {
    if (getCookie('unsupportedBrowser') === '1') return
    const { result, browser, url } = isLowerBrowserForWebP()
    setShow(result)
    setUrl(url)
    setBrowser(browser)
  }, [])

  const handleClick = () => {
    setCookie('unsupportedBrowser', '1', 365)
    setShow(false)
  }

  return show ? (
    <Wrapper>
      This version of {browser} is not supported.
      <SecondLine>
        Please
        <a href={url} rel='nofollow'>
          upgrade to a supported version.
        </a>
        <Dismiss onClick={() => handleClick()}>Dismiss</Dismiss>
      </SecondLine>
    </Wrapper>
  ) : null
}
